module.exports = __webpack_public_path__ + "static/media/What-This-Series-Is-About.41e633d5.md";